import React, {Fragment, useEffect, useState} from "react";
import AdminComponent from "../../auth/AdminComponent/AdminComponent";
import {CommonTextControlProps} from "./CommonTextControl.model";

const CommonTextControl = (
  {
    header,
    getTextCommand,
    setTextCommand,
    onValueChanged,
    initialValue,
    label,
    maxLength = null,
    readOnly = false,
    type = "text",
    autoLoad = false
  }: CommonTextControlProps) => {
  const [loading, setLoading] = useState(false);
  const [inputText, setInputText] = useState<string>("");

  useEffect(() => {
    if (initialValue == null)
      return;

    setInputText(String(initialValue))
  }, [initialValue])

  useEffect(() => {
    if (autoLoad && typeof getTextCommand === 'function') {
      getInputTextCommand().then();
    }
  }, [autoLoad]);

  const getInputTextCommand = async (e: React.MouseEvent<HTMLButtonElement> | null = null) => {
    if (e) {
      e.preventDefault();
    }

    if (typeof getTextCommand !== "function") return;

    setLoading(true);

    try {
      const result = await getTextCommand();
      updateInputText(result)
    } finally {
      setLoading(false);
    }
  }

  const setInputTextCommand = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (typeof setTextCommand !== "function") return;

    setLoading(true);

    try {
      if (type === "number") {
        await setTextCommand(Number(inputText))
      } else {
        const utf8Encode = new TextEncoder();
        const bytes = utf8Encode.encode(inputText + '\n');
        const bytesArray = Array.from(bytes);

        await setTextCommand(bytesArray)
      }
    } finally {
      setLoading(false);
    }
  }

  const updateInputText = (text: string | number) => {
    setInputText(String(text))

    if (typeof (onValueChanged) === 'function') {
      onValueChanged(String(text))
    }
  }

  const spin = loading
    ? <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    : null;

  return (
    <Fragment>
      <p>{header}</p>
      <fieldset disabled={loading}>
        <div className="row">
          <div className="col">
            <div className="input-group mb-3 col">
              {
                !!label
                  ?
                  (
                    <div className="input-group-text">
                      <label className="form-label">{label}</label>
                    </div>
                  )
                  : null
              }
              <input className="form-control"
                     type={type}
                     maxLength={maxLength ?? undefined}
                     onChange={(event) => {
                       updateInputText(event.target.value)
                     }}
                     value={inputText}
                     readOnly={readOnly}
              />
              <AdminComponent>
                {
                  () => (
                    <Fragment>
                      {
                        typeof (setTextCommand) === 'function' ?
                          <button className="btn btn-primary" type="button" onClick={setInputTextCommand} disabled={loading}>
                            {spin}
                            Записать
                          </button>
                          : null
                      }
                    </Fragment>
                  )
                }
              </AdminComponent>
              {
                typeof (getTextCommand) === 'function' ?
                  <button className="btn btn-outline-secondary" type="button" onClick={getInputTextCommand} disabled={loading}>
                    {spin}
                    {loading ? 'Загрузка...' : 'Обновить'}
                  </button>
                  : null
              }
            </div>
          </div>
        </div>
      </fieldset>
    </Fragment>
  )
}

export default CommonTextControl;
